// src/Layouts/AdminLayout.js
import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import './admin.css';
import AdminNavbar from './adminNavbar';

const AdminLayout = ({ onLogout }) => {
    const location = useLocation();
    const showEventSubNav = location.pathname.startsWith('/admin/events');

    return (
        <div className="admin-layout">
            <AdminNavbar onLogout={onLogout} />
            {showEventSubNav && (
                <div className="admin-subnav">
                </div>
            )}
            <main className="admin-main-content">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;